import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const TermCard = ({ className, id, term }) => {
  return (
    <Link
      to={`etapas/${id}/edit`}
      className={`${className} card-100 card-body`}
    >
      <div className="d-flex justify-space-between">
        <p className="semi-bold brown text-underline">
          {term.name} - {term.course_offer.course}
        </p>
      </div>
      <div className="d-flex align-items-center mb-2">
        <div className="mr-3">
          <span className="brown">Sigla:</span> {term.abbreviation}{' '}
        </div>
        <div className="mr-3">
          <span className="brown">Número da etapa:</span> {term.number}{' '}
        </div>
      </div>
    </Link>
  );
};

TermCard.propTypes = {
  className: PropTypes.string,
  term: PropTypes.object.isRequired,
  id: PropTypes.number.isRequired,
};

TermCard.defaultProps = {
  className: '',
};

export default TermCard;
